import { z } from "zod";
import { PRESERVATION_TRIGGER_TYPES } from "./preservations.constants";

export const PreservationSchema = z
  .object({
    id: z.number(),
    uuid: z.string(),
    name: z.string(),
    description: z.string(),
    contact: z
      .object({
        id: z.number(),
        name: z.string(),
        email: z.string(),
        organization: z.string(),
      })
      .nullable(),
    case: z.object({
      id: z.number(),
      uuid: z.string(),
      case_number: z.string(),
      case_name: z.string(),
    }),
    evidence: z
      .object({
        id: z.number(),
        uuid: z.string(),
        name: z.string(),
        evidence_number: z.string(),
      })
      .nullable(),
    acquisition: z
      .object({
        id: z.number(),
        uuid: z.string(),
        name: z.string(),
      })
      .nullable(),
    status: z.object({
      id: z.number(),
      name: z.string(),
    }),
    trigger_date: z.string().nullable(),
    trigger_type: z.object({
      id: z.number(),
      name: z.string(),
    }),
    method: z.object({
      id: z.number(),
      name: z.string(),
    }),
    start_date: z.string().nullable(),
    end_date: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .strict();

export const GetPreservationsSchema = z
  .object({
    id: z.coerce.number().optional(),
    uuid: z.string().optional(),
    name: z.string().optional(),
    contact_id: z.coerce.number().optional(),
    case_id: z.coerce.number().optional(),
    search: z.string().optional(),
    sort_by: z.string().optional(),
    sort_dir: z.enum(["asc", "desc"]).optional(),
    page_size: z.coerce.number().min(1).max(1000).optional(),
    page: z.coerce.number().min(1).optional(),
  })
  .strict();

export const DefaultPreservationSchema = z.object({
  case_id: z.coerce.number(),
  name: z.string().min(1, { message: "Name is required" }),
  trigger_type_id: z.number().optional().nullable(),
  trigger_date: z.string().optional().nullable(),
  method_id: z.number().optional().nullable(),
  status_id: z.number().optional().nullable(),
  contact_id: z.number().optional().nullable(),
  evidence_id: z.number().optional().nullable(),
  acquisition_id: z.number().optional().nullable(),
  start_date: z.string().optional().nullable(),
  end_date: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
});

export const CreatePreservationSchema = DefaultPreservationSchema.extend({
  uuid: z.string().optional(),
}).strict();

export const UpdatePreservationSchema = DefaultPreservationSchema.extend({
  uuid: z.string(),
  name: z.string().optional(),
  case_id: z.coerce.number().optional(),
}).strict();

export const DeletePreservationSchema = z.object({ uuid: z.string() }).strict();
